import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:stationId',
      redirect: to => {
        return `/${to.params.stationId}/home`;
      }
    },
    {
      path: '/:stationId/login',
      component: resolve => require(['../components/user/Login.vue'], resolve),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/:stationId/register',
      component: resolve => require(['../components/user/register.vue'], resolve),
      meta: {
        title: '注册'
      }
    },
    
    {
      path: '/:stationId/home/:projectId?',
      component: resolve => require(['../components/Home.vue'], resolve),
    }
    ,
    
    {
      path: '/:stationId/jobs/:projectId?',
      component: resolve => require(['../components/zpzw.vue'], resolve),
      meta: {
        title: '职位列表'
      }
    },
    {
      path: '/:stationId/apply-data/:projectId?',
      component: resolve => require(['../components/bmsj.vue'], resolve),
      meta: {
        title: '报名数据'
      }
    }
    ,
    {
      path: '/:stationId/news/:projectId?',
      component: resolve => require(['../components/ksdt.vue'], resolve),
      meta: {
        title: '考试动态'
      }
    }
    ,
    {
      path: '/:stationId/news-detail/:id/:projectId?',
      component: resolve => require(['../components/ksdtDetail.vue'], resolve),
      meta: {
        title: '动态详情'
      }
    },
    {
      path: '/:stationId/help-center/:projectId?',
      component: resolve => require(['../components/HelpCenter.vue'], resolve),
      meta: {
        title: '帮助中心'
      }
    },
    {
      path: '/:stationId/faq/:projectId?',
      component: resolve => require(['../components/Faq.vue'], resolve),
      meta: {
        title: '常见问题'
      }
    },
    {
      path: '/:stationId/user-guide/:projectId?',
      component: resolve => require(['../components/UserGuide.vue'], resolve),
      meta: {
        title: '使用指南'
      }
    },
    {
      path: '/:stationId/help-detail/:projectId?',
      component: resolve => require(['../components/HelpDetail.vue'], resolve),
      meta: {
        title: '帮助详情'
      }
    },
    {
      path: '/:stationId/user-center/:projectId?',
      component: resolve => require(['../components/grzx.vue'], resolve),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/:stationId/submit/:projectId?',
      component: resolve => require(['../components/Txbmzl.vue'], resolve),
      meta: {
        title: '提交报名资料'
      }
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js